export const appConfig = {
  registrationApiUrl: "https://script.google.com/macros/s/AKfycbyFajkbi0LwiuuC3b3f6ryuF1FVWWMNG0aWGiEKa_5ifeWuq_Pw0kvd1RigdtQCSMo/exec",
};
